import {createFileRoute, redirect} from '@tanstack/react-router';
import ImagesProtocolRequest from '@/patient/views/imageProtocol/ImagesProtocolRequest';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute('/(patient)/patient/image-protocol-request')({
  component: ImagesProtocolRequest,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    const company = context.company;
    if (!company?.isTakePhotoEnabledForPatient || !company.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
